import { useEffect, useRef, useState } from 'react'

type ChangeHandler<TEvent> = (e: TEvent) => void

export function useCursorPreserver<
  TElement extends HTMLInputElement | HTMLTextAreaElement,
  TEvent = React.ChangeEvent<TElement>,
>(value: unknown, onChange?: ChangeHandler<TEvent>) {
  const [cursor, setCursor] = useState<number | null>(null)
  const ref = useRef<TElement>(null)

  useEffect(() => {
    const el = ref.current
    if (el && cursor !== null) {
      el.setSelectionRange(cursor, cursor)
    }
  }, [cursor, value])

  const handleChange: ChangeHandler<TEvent> = (e: TEvent) => {
    const el = ref.current

    if (el && typeof el.selectionStart === 'number') {
      setCursor(el.selectionStart)
    }

    onChange?.(e)
  }

  return {
    ref,
    handleChange,
  }
}
